import React from 'react';
import Heading from 'app_previous/elements/typography/heading';
import {
  Caption,
  ImageBlock,
  ResourceBottomCallToActionContainer,
  ResourceBottomCallToActionContent,
  TextBlock,
} from './ResourceBottomCallToAction.styles';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { IStaticContentfulImages } from 'src/types/contentful';
import Button from 'atoms/Button/Button';

interface ResourceBottomCallToActionProps {
  ctaBottomText?: string;
  image?: IGatsbyImageData;
  buttonProps?: {
    text?: string;
    url?: string;
    showCaption?: boolean;
  };
}

const ResourceBottomCallToAction = ({
  ctaBottomText,
  image,
  buttonProps = {},
}: ResourceBottomCallToActionProps): JSX.Element => {
  const { phoneImage } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      phoneImage: contentfulAsset(contentful_id: { eq: "2YoRet2U92iA6TkPvPpz8J" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 650)
      }
    }
  `);

  const {
    url = 'https://cohost.mn.co?plan=free-trial',
    text = 'Start Your Own Mighty Network Today!',
    showCaption = true,
  } = buttonProps;

  return (
    <ResourceBottomCallToActionContainer data-section-name='Resource center article bottom CTA'>
      <ResourceBottomCallToActionContent>
        <TextBlock>
          <Heading
            text={ctaBottomText || 'Ready to start building your community?'}
            standardSize='2.125'
            className='ready-to-start-building-headline'
            weight='normal'
            align='left'
            color='white'
          />
          <Button
            href={url}
            size='lg'
            variant='primary'
          >
            {text}
          </Button>
          {/* Use this customized caption in order to fit in the grid layout */}
          {showCaption && <Caption>No credit card required.</Caption>}
        </TextBlock>
        <ImageBlock>
          <GatsbyImage
            image={image ?? phoneImage.gatsbyImageData}
            alt=''
          />
        </ImageBlock>
      </ResourceBottomCallToActionContent>
    </ResourceBottomCallToActionContainer>
  );
};

export default ResourceBottomCallToAction;
